module.exports = __webpack_public_path__ + "fonts/mallorymp-book-webfont.7ebe168d5c862ee8e076085faf947e57.woff";